// @flow
import * as React from 'react';
import { DashboardCard } from '../dashboard-card';
import {
  useFollowUpsFutureQuery,
  useFollowUpsQuery,
  useMissedAppsTagId,
  useSameDayTagId,
} from '../../../../../../shared';
import { ButtonBase, Stack, Typography } from '@mui/material';
import { CircularProgressWithLabel } from '../circular-progress-with-label';
import { useOutdatedFollowUps } from '../../../../hooks/use-outdated-follow-ups';
import { Link } from 'react-router-dom';
import { getRoute } from '../../../../../../app/router';
import { NavButton } from '../nav-button';

type Props = {
  agentId?: string
};
export const FollowUpCard = ({agentId}: Props) => {
  const missingAppsTagId = useMissedAppsTagId();
  const sameDayTagId = useSameDayTagId();
  const outdated = useOutdatedFollowUps(agentId)
  const {data: followUpsData} = useFollowUpsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      pageInput: {page: 0, size: 1},
      excludedTagsIds: [missingAppsTagId],
    },
    skip: !agentId || !missingAppsTagId,
  });
  const followUpsCount = followUpsData?.followUps.totalElements;

  const {data: futureData} = useFollowUpsFutureQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      pageInput: {page: 0, size: 1},
      excludedTagsIds: [missingAppsTagId],
    },
    skip: !agentId || !missingAppsTagId,
  });
  const futureCount = futureData?.followUpsFuture.totalElements;

  const {data: sameDayData} = useFollowUpsQuery({
    fetchPolicy: 'cache-and-network',
    variables: {
      agentId,
      pageInput: {page: 0, size: 1},
      excludedTagsIds: [missingAppsTagId],
      includedTagsIds: [sameDayTagId]
    },
    skip: !agentId || !missingAppsTagId,
  });
  const sameDayCount = sameDayData?.followUps.totalElements;

  const percent = +followUpsCount ? Math.round((outdated?.length || 0) / followUpsCount * 100) : 0;

  const title = percent === 0 ? '100% up to date' : percent < 10 ? `${100 - percent}% are up to date` : `${percent}% outdated `;
  const color = percent === 0 ? 'success' : percent < 10 ? 'info' : 'error';

  return (
    <DashboardCard>
      <Typography variant={'h3'} mb={1}>Follow-Ups</Typography>

      <Typography variant={'body2'} mb={1} color={`${color}.600`} align={'center'}>Next Contact Dates: <b>{title}</b></Typography>
      <CircularProgressWithLabel color={color} size={100} value={100 - percent} thickness={2}>
        <ButtonBase sx={{mt: 1, flexDirection: 'column', alignItems: 'center', p: 1, borderRadius: 2}} component={Link} to={`/${getRoute('dashboard')}/today-follow-ups/${agentId}`}>
          <Typography lineHeight={'1!important'} variant={'h1'}>{followUpsCount - (outdated?.length || 0)}</Typography>
          <Typography variant={'caption'} align={'center'}>Today</Typography>
        </ButtonBase>
      </CircularProgressWithLabel>

      <Stack direction={'row'} gap={2} mt={2}>
        <NavButton to={`/${getRoute('dashboard')}/outdated-follow-ups/${agentId}`} color={outdated?.length ? '#DE3124' : 'success.500'}>
          <Typography variant={'subtitle1'} align={'center'} color={`${outdated?.length ? 'error' : 'success'}.500`}>{outdated?.length || 0}</Typography>
          <Typography variant={'caption'} align={'center'} color={`${outdated?.length ? 'error' : 'success'}.500`}>Outdated</Typography>
        </NavButton>
        <NavButton to={`/${getRoute('dashboard')}/future-follow-ups/${agentId}`} color={'#0288d1'}>
          <Typography variant={'subtitle1'} align={'center'} color={'#0288d1'}>{futureCount}</Typography>
          <Typography variant={'caption'} align={'center'} color={'#0288d1'}>Future</Typography>
        </NavButton>
      </Stack>
    </DashboardCard>
  );
};
